module.exports = __webpack_public_path__ + "img/tourbillon-grey.b9bc5526.svg";